define([
	"dojo/_base/declare",
	"csi/heading/AggregateController",
	"csi/page",
	"csi/state/rootStore",
	"csi/xml",
	"csi/widget/MessageDialog"
], function(declare,AggregateController,page,{ routerStore },xml,MessageDialog) {

	return declare(AggregateController, {
		getConfirmButton: function() {
			return MessageDialog.BUTTON_CHANGE;
		},
		
		publish: function() {
			// summary: confirm action before continuing
			if (xml.isValidURL(this.getNode().__Parent__)) {
				this.confirmAction();
			} else {
				this.inherited(arguments);
			}
		},

		onConfirm: function(/*String*/key) {
			// summary: if configured to confirm action, then start now that confirmed
			if (key == MessageDialog.BUTTON_CHANGE) {
				AggregateController.prototype.publish.call(this);
			} else {
				this.postProcess();
			}
		},

		/**
		 * @override
		 * Update UI based on change in node hierarchy
		 */
		postProcessSuccess: function() {
			const type = this.getNode().$Type;

			if (routerStore.getBreadcrumbNode(type)) {
				// if item is in breadcrumb trail, then refresh breadcrumb
				page.refreshRootView();
			} else if (this.getParent() && this.getParent().$Type.endsWith("SecurityGroup")) {
				//C8-425  When I deselect an MSG for a Material, Material is still displayed under the MSG until a page refresh is given
				this.widget.refreshData();
			}

			this.inherited(arguments);
		}
	});
});